import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiDeBiltSchipholPage() {
  return (
    <CityAirportTemplate
      city="De Bilt"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={57.50}
      distance="48 km"
      duration="38-42 minuten"
    />
  );
}
